"use client";
import styles from "./Banner.module.scss";
import dynamic from "next/dynamic";
import { useEffect, useState } from "react";
import Image from "components/common/Image";

import cx from "classnames";
import { map, get, isString } from "utils/lodash";
import { useRouteContext } from "providers/RouteProvider";

// Swiper (~95KB) không cần lúc tải trang: màn đầu render ảnh tĩnh slide 1,
// khi trình duyệt rảnh mới nạp Swiper để chạy autoplay -> giảm TBT trang chủ.
const Swiper = dynamic(() => import("components/common/Swiper"), {
  ssr: false,
});
const RenderBanner = (item: any, index?: number) => {
  const { router } = useRouteContext();
  const deepLink = isString(get(item, "linkUrl")) ? get(item, "linkUrl") : "";
  // Banner đầu trang chủ thường là ảnh LCP — slide đầu (index 0) cần priority
  // + sizes đúng khổ container (max-w của .container, không phải 100vw) để
  // browser tải đúng kích thước, không quá khổ.
  const isFirst = index === 0;
  return (
    <div
      onClick={() => {
        router.handleDeepLink(deepLink);
      }}
      className="w-full aspect-[375/70] cursor-pointer"
    >
      <Image
        wrapClassName="w-full aspect-[375/70]"
        src={get(item, "src") || get(item, "url") || item}
        alt={get(item, "alt") || "Banner"}
        priority={isFirst}
        sizes="(min-width: 1280px) 1232px, 100vw"
      />
    </div>
  );
};
const Banner = ({ data, banner = "" }: { data: any; banner?: string }) => {
  let images = [{ src: banner }];
  if (data) {
    images = map(get(data, "images"), (item) => ({
      ...item,
      src: get(item, "image.url"),
      alt: get(item, "altText") || get(item, "image.alt") || "",
    }));
  }

  const [ready, setReady] = useState(false);
  useEffect(() => {
    if (!images || images.length < 2) return;
    const w = window as any;
    if (w.requestIdleCallback) {
      const id = w.requestIdleCallback(() => setReady(true), { timeout: 3000 });
      return () => w.cancelIdleCallback(id);
    }
    const t = setTimeout(() => setReady(true), 2000);
    return () => clearTimeout(t);
  }, [images?.length]);

  return (
    <div className={cx("bg-white", styles.banner)}>
      <div className="container mx-auto p-2">
        {/* Khung cố định tỉ lệ: đổi ảnh tĩnh -> Swiper không đẩy layout (CLS) */}
        <div className="relative w-full aspect-[375/70] overflow-hidden">
        {images && images.length > 0 && !ready && RenderBanner(images[0], 0)}
        {images && images.length > 1 && ready && (
          <Swiper
            classNameSlide="w-full aspect-[375/70]"
            data={images}
            renderItem={RenderBanner}
            autoplay={{ delay: 3000, disableOnInteraction: false }}
            pagination={{ clickable: true }}
          />
        )}
        </div>
      </div>
    </div>
  );
};

export default Banner;
